<template>
    <div class="content-wrapper">
      <div class="container-lg">
        <div class="page-title-nav row">
          <div class="col-2 col-lg-3">
            <router-link :to="`/sakha`" class="btn btn-outline-secondary btn-custom btn-back">
              <i class="fa-icon fa-regular fa-arrow-left me-0"></i><span class="d-none d-lg-block ms-2">ย้อนกลับ</span>
            </router-link>
          </div>
          <div class="col-8 col-lg-6">
            <h1 class="page-title">ลืมรหัสผ่าน</h1>
          </div>
          <div class="col-12 col-lg-3">
            <a href="#" class="btn btn-primary btn-custom d-none"><i
                class="fa-icon fa-regular fa-home"></i><span>button</span></a>
          </div>
        </div>
        <div class="row mb-12 justify-content-center">
          <div class="col">
            <div class="content-card mb-4">
              <div class="content-card mb-4">
                <div class="content-card-title">
                  <h6 class="font-weight-normal mb-0"><span class="badge  bg-label-success ">STEP 1</span> ระบุเบอร์โทร
                  </h6>
                </div>
                <div class="content-card-body">
                  <div class="row mb-5">
                    <div class="col">
                      <i class="fa-solid fa-mobile-screen-button fa-fw"></i> ลืมรหัสผ่าน เพียงแค่ใส่เบอร์ที่เคยใช้สมัคร
                    </div>
                  </div>
                  <div class="row mb-5">
                    <div class="col-4 col-sm-4 col-md-2 d-flex align-items-center justify-content-md-end">
                      <span class="flag-icon flag-icon-th mr-1"></span>&nbsp;&nbsp; +66
                    </div>
                    <div class="col-8 col-sm-8 col-md-4">
                      <div class="form-password-toggle">
                        <div class="input-group input-group-sm input-group-merge">
                          <input type="tel" name="tel" class="form-control telinput" maxlength="10" required=""
                            v-model="mobilePhone" />
                          <span class="input-group-text cursor-pointer"> <i
                              class="fa-solid fa-mobile-screen-button fa-fw"></i></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 text-right text-sm-right text-md-left">
                      <small class="text-secondary">กรุณาใส่หมายเลขโทรศัพท์เพื่อยืนยันตัวตน</small>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col">
                      <router-link :to="`/sakha`" class="btn btn-secondary btn-block w-100">
                        <i class="fa-icon fa-regular fa-arrow-left ms-2"></i><span
                          class=" ms-2 ">ยกเลิก</span>
                      </router-link>
                    </div>
                    <div class="col">
                      <button @click="onSubmit" class="btn  btn-primary w-100 btn-block">
                        ถัดไป <i class="fa-icon fa-regular fa-arrow-right ms-2"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { checkNumber } from '@/utils/number'
import { submitForgetService } from '@/services'
export default {
  data () {
    return {
      mobilePhone: ''
    }
  },
  watch: {
    mobilePhone: function (value) {
      if (!checkNumber(value)) {
        this.mobilePhone = value.substring(0, value.length - 1)
      } else if (value.length === 1 && value !== '0') {
        this.mobilePhone = '0' + value
      }
      if (value.length > 10) {
        this.mobilePhone = value.substring(0, 10)
      }
    }
  },
  methods: {
    ...mapActions(['setLoading', 'setMobilePhone']),
    async onSubmit () {
      try {
        this.setLoading(true)
        const resp = await submitForgetService({ mobilePhone: this.mobilePhone })
        if (resp.status_code === 'SUCCESS') {
          this.setMobilePhone(this.mobilePhone)
          this.$router.replace('/forgot-verify')
          // this.$router.replace('/reset')
        }
        this.setLoading(false)
      } catch (error) {
        this.setLoading(false)
      }
    }
  }
}
</script>

<style></style>
